interface Theme {
  id: number;
  text: string;
  name: string;
}

const themes: Theme[] = [
  { id: 1, text: 'Light', name: 'light-theme' },
  { id: 2, text: 'ViewNexa Light', name: 'light-theme-viewnexa' },
  { id: 3, text: 'Dark', name: 'dark-theme' },
  { id: 4, text: 'ViewNexa Dark', name: 'dark-theme-viewnexa' },
];

let selectedTheme: Theme | undefined;
const themeSelector = {
  getTheme: () => {
    return selectedTheme;
  },

  setTheme: (name: string) => {
    let theme: Theme | undefined;
    theme = themes.find((t) => t.name === name);

    if (!theme) {
      theme = themes[0];
    }

    const body = document.getElementsByTagName('body')[0];
    if (body) {
      body.removeAttribute('class');
      body.classList.add(theme.name);
    }

    require(`../src/assets/themes/${theme.name}/index.scss`);
    // lastly set the theme in local storage
    localStorage.setItem('app-theme', theme.name);

    selectedTheme = theme;
  },
};

export { Theme, themes, themeSelector };
